/**
 * My Ministries Service
 * Self-service, read-only: the signed-in user's own ministries, departments and designations.
 * Any signed-in user (no Ministry / Member.* right needed). A login with no member record gets
 * empty lists. The backend resolves the caller's MemberID from the shared Member cache, then
 * MemberManagement's internal API.
 * Microservice: departmentmanagement
 * Route: api/me (MyMinistriesController.cs)
 */
import { BaseService } from '../base/BaseService';
export class MyMinistriesService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MyMinistriesService.DEFAULT_SERVICE_PATH,
            basePath: MyMinistriesService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * My ministries (active memberships) with ministry and role names
     * GET /api/me/ministries
     */
    async getMyMinistries() {
        const response = await this.getMyMinistriesRaw();
        return response.data ?? [];
    }
    getMyMinistriesRaw() {
        return this.http.get(this.buildUrl(this.getEndpoint('ministries', 'ministries')));
    }
    /**
     * My department memberships (active first)
     * GET /api/me/departments
     */
    async getMyDepartments() {
        const response = await this.getMyDepartmentsRaw();
        return response.data ?? [];
    }
    getMyDepartmentsRaw() {
        return this.http.get(this.buildUrl(this.getEndpoint('departments', 'departments')));
    }
    /**
     * My designations (roles; main first)
     * GET /api/me/designations
     */
    async getMyDesignations() {
        const response = await this.getMyDesignationsRaw();
        return response.data ?? [];
    }
    getMyDesignationsRaw() {
        return this.http.get(this.buildUrl(this.getEndpoint('designations', 'designations')));
    }
}
MyMinistriesService.DEFAULT_SERVICE_PATH = 'departments';
MyMinistriesService.BASE_PATH = 'api/me';
//# sourceMappingURL=MyMinistriesService.js.map